import React from 'react';
import { SectionWrapper } from './SectionWrapper';
const forYou = ['Intentaste la ley de atracción antes pero sin resultados consistentes', 'Querés un sistema que integre mente, cuerpo y sueño', 'Podés dedicar 35 minutos diarios', 'Estás dispuesto a seguir un protocolo por 21 días', 'Querés herramientas prácticas, no solo teoría'];
const notForYou = ['Buscás un milagro sin hacer nada', 'No podés comprometer 35 minutos diarios', 'Querés resultados sin ningún proceso', 'No estás dispuesto a implementar lo que leés'];
export function ForWhoSection() {
  return <SectionWrapper bgColor="bg-brand-black" data-id="element-103">
      <div className="grid md:grid-cols-2 gap-10 md:gap-12" data-id="element-104">
        <div data-id="element-105">
          <h3 className="font-heading text-xl md:text-2xl text-brand-ivory font-semibold mb-6" data-id="element-106">
            Este sistema ES para vos si:
          </h3>
          <div className="space-y-4" data-id="element-107">
            {forYou.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-108">
                <span className="text-emerald-400 shrink-0 mt-0.5" data-id="element-109">✅</span>
                <p className="text-brand-ivory/80 font-body text-base" data-id="element-110">
                  {item}
                </p>
              </div>)}
          </div>
        </div>

        <div data-id="element-111">
          <h3 className="font-heading text-xl md:text-2xl text-brand-ivory font-semibold mb-6" data-id="element-112">
            Este sistema NO es para vos si:
          </h3>
          <div className="space-y-4" data-id="element-113">
            {notForYou.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-114">
                <span className="text-red-400/80 shrink-0 mt-0.5" data-id="element-115">❌</span>
                <p className="text-brand-muted font-body text-base" data-id="element-116">{item}</p>
              </div>)}
          </div>
        </div>
      </div>
    </SectionWrapper>;
}